// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ------------------------------------------------------------------
 * Payment screens — theme-aligned with the rest of the app.
 * Brand primary: #0576b7   Light accent: #e8f4fb   Border: #d0e8f8
 * ------------------------------------------------------------------ */

.paymentScreen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}

/* Custom phone input styling */
.custom-phone-input {
  display: flex !important;
  align-items: center !important;
  width: 100% !important;
  box-sizing: border-box !important;
}

.custom-phone-input input {
  border: none !important;
  outline: none !important;
  font-size: 16px !important;
  background: transparent !important;
  padding-left: 8px !important;
  flex: 1 1 !important;
  height: 24px !important;
}

.custom-phone-input:focus-within {
  border-color: #0576b7 !important;
  box-shadow: 0 0 0 3px rgba(5, 118, 183, 0.12) !important;
}

.custom-phone-input .PhoneInputCountrySelect {
  border: none !important;
  background: transparent !important;
  margin-right: 8px !important;
  outline: none !important;
}

.custom-phone-input .PhoneInputCountrySelectArrow {
  color: #0576b7 !important;
}

.custom-phone-input .PhoneInputCountryIcon {
  margin-right: 4px !important;
}

/* Phone input wrapper fixes */
.phone-input-wrapper {
  position: relative;
  width: 100%;
}

.phone-input-wrapper .PhoneInput {
  width: 100% !important;
}

.PhoneInputCountrySelect:focus {
  outline: none !important;
  box-shadow: none !important;
}

@media (max-width: 768px) {
  .paymentScreen {
    padding: 10px;
  }

  .paymentBox {
    max-width: 100%;
  }

  .custom-phone-input {
    font-size: 14px !important;
  }
}

/* Brand-aligned focus rings on antd inputs inside the payment flow */
.paymentScreen .ant-input:focus,
.paymentScreen .ant-input-focused,
.paymentScreen .ant-input-affix-wrapper-focused {
  border-color: #0576b7 !important;
  box-shadow: 0 0 0 3px rgba(5, 118, 183, 0.12) !important;
}

/* Payment CTA button — brand-aligned hover */
.payment-button {
  transition: all 0.25s ease !important;
}

.payment-button:hover {
  background: #045f95 !important;
  box-shadow: 0 8px 22px rgba(5, 118, 183, 0.28) !important;
}

.payment-button:active {
  background: #034f7d !important;
  box-shadow: 0 4px 14px rgba(5, 118, 183, 0.2) !important;
}

.phone-input-wrapper:focus-within {
  border-color: #0576b7 !important;
  box-shadow: 0 0 0 3px rgba(5, 118, 183, 0.12) !important;
}

/* Result page (success / failed / loading) ------------------------- */

.payment-result-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #f5f7fa;
  padding: 24px;
}

.payment-result-card {
  width: 100%;
  max-width: 560px;
  border-radius: 12px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.06);
  border: 1px solid #e5e7eb;
  overflow: hidden;
}

.payment-result-card .ant-card-body {
  padding: 40px 32px;
}

/* Status icon transitions */
.payment-success-icon,
.payment-failed-icon {
  opacity: 0;
  transform: scale(0);
  transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.payment-success-icon.animate {
  opacity: 1;
  transform: scale(1);
  animation: brandPulse 1.6s ease-in-out;
}

.payment-failed-icon.animate {
  opacity: 1;
  transform: scale(1);
  animation: brandShake 0.9s ease-in-out;
}

@keyframes brandPulse {
  0%   { transform: scale(0);   opacity: 0; }
  55%  { transform: scale(1.08); }
  100% { transform: scale(1);   opacity: 1; }
}

@keyframes brandShake {
  0%   { transform: scale(0)    rotate(0deg);  opacity: 0; }
  50%  { transform: scale(1.08) rotate(-4deg); }
  75%  { transform: scale(1.04) rotate(3deg); }
  100% { transform: scale(1)    rotate(0deg);  opacity: 1; }
}

/* Inline info / error blocks on the result card */
.payment-info-block {
  background: #e8f4fb;
  border: 1px solid #d0e8f8;
  border-radius: 8px;
  padding: 12px 16px;
  margin-top: 12px;
  text-align: left;
}

.payment-info-block .payment-info-text {
  font-size: 14px;
  color: #045f95;
}

.error-details {
  background: #fff2f0;
  border: 1px solid #ffccc7;
  border-radius: 8px;
  padding: 14px 16px;
  margin-top: 12px;
  text-align: left;
}

.error-details ul {
  margin: 8px 0 0;
  padding-left: 20px;
  color: #666;
}

.error-details li {
  margin-bottom: 4px;
}

/* Subtle button motion in the result page (not too punchy) */
.payment-result-container .ant-btn {
  transition: all 0.2s ease;
}

.payment-result-container .ant-btn:hover {
  transform: translateY(-1px);
}

/* Loading dot color matches the brand */
.ant-spin-dot-item {
  background-color: #0576b7 !important;
}

@media (max-width: 768px) {
  .payment-result-container {
    padding: 12px;
  }

  .payment-result-card .ant-card-body {
    padding: 24px 18px;
  }

  .payment-success-icon,
  .payment-failed-icon {
    font-size: 60px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/screens/payment/styles.css"],"names":[],"mappings":"AAAA;;;uEAGuE;;AAEvE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,kCAAkC;EAClC,4BAA4B;EAC5B,oBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,qEAAqE;AACrE;;;EAGE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA,6CAA6C;AAC7C;EACE,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,yDAAyD;AAC3D;;AAEA;EACE,8BAA8B;EAC9B,wDAAwD;AAC1D;;AAEA;EACE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA,uEAAuE;;AAEvE;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;;EAEE,UAAU;EACV,mBAAmB;EACnB,4DAA4D;AAC9D;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,OAAO,mBAAmB,IAAI,UAAU,EAAE;EAC1C,OAAO,sBAAsB,EAAE;EAC/B,OAAO,mBAAmB,IAAI,UAAU,EAAE;AAC5C;;AAEA;EACE,OAAO,mCAAmC,GAAG,UAAU,EAAE;EACzD,OAAO,oCAAoC,EAAE;EAC7C,OAAO,mCAAmC,EAAE;EAC5C,OAAO,mCAAmC,GAAG,UAAU,EAAE;AAC3D;;AAEA,kDAAkD;AAClD;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA,6DAA6D;AAC7D;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,wCAAwC;AACxC;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,0BAA0B;EAC5B;AACF","sourcesContent":["/* ------------------------------------------------------------------\n * Payment screens — theme-aligned with the rest of the app.\n * Brand primary: #0576b7   Light accent: #e8f4fb   Border: #d0e8f8\n * ------------------------------------------------------------------ */\n\n.paymentScreen {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n}\n\n/* Custom phone input styling */\n.custom-phone-input {\n  display: flex !important;\n  align-items: center !important;\n  width: 100% !important;\n  box-sizing: border-box !important;\n}\n\n.custom-phone-input input {\n  border: none !important;\n  outline: none !important;\n  font-size: 16px !important;\n  background: transparent !important;\n  padding-left: 8px !important;\n  flex: 1 !important;\n  height: 24px !important;\n}\n\n.custom-phone-input:focus-within {\n  border-color: #0576b7 !important;\n  box-shadow: 0 0 0 3px rgba(5, 118, 183, 0.12) !important;\n}\n\n.custom-phone-input .PhoneInputCountrySelect {\n  border: none !important;\n  background: transparent !important;\n  margin-right: 8px !important;\n  outline: none !important;\n}\n\n.custom-phone-input .PhoneInputCountrySelectArrow {\n  color: #0576b7 !important;\n}\n\n.custom-phone-input .PhoneInputCountryIcon {\n  margin-right: 4px !important;\n}\n\n/* Phone input wrapper fixes */\n.phone-input-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.phone-input-wrapper .PhoneInput {\n  width: 100% !important;\n}\n\n.PhoneInputCountrySelect:focus {\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n@media (max-width: 768px) {\n  .paymentScreen {\n    padding: 10px;\n  }\n\n  .paymentBox {\n    max-width: 100%;\n  }\n\n  .custom-phone-input {\n    font-size: 14px !important;\n  }\n}\n\n/* Brand-aligned focus rings on antd inputs inside the payment flow */\n.paymentScreen .ant-input:focus,\n.paymentScreen .ant-input-focused,\n.paymentScreen .ant-input-affix-wrapper-focused {\n  border-color: #0576b7 !important;\n  box-shadow: 0 0 0 3px rgba(5, 118, 183, 0.12) !important;\n}\n\n/* Payment CTA button — brand-aligned hover */\n.payment-button {\n  transition: all 0.25s ease !important;\n}\n\n.payment-button:hover {\n  background: #045f95 !important;\n  box-shadow: 0 8px 22px rgba(5, 118, 183, 0.28) !important;\n}\n\n.payment-button:active {\n  background: #034f7d !important;\n  box-shadow: 0 4px 14px rgba(5, 118, 183, 0.2) !important;\n}\n\n.phone-input-wrapper:focus-within {\n  border-color: #0576b7 !important;\n  box-shadow: 0 0 0 3px rgba(5, 118, 183, 0.12) !important;\n}\n\n/* Result page (success / failed / loading) ------------------------- */\n\n.payment-result-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: #f5f7fa;\n  padding: 24px;\n}\n\n.payment-result-card {\n  width: 100%;\n  max-width: 560px;\n  border-radius: 12px;\n  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.06);\n  border: 1px solid #e5e7eb;\n  overflow: hidden;\n}\n\n.payment-result-card .ant-card-body {\n  padding: 40px 32px;\n}\n\n/* Status icon transitions */\n.payment-success-icon,\n.payment-failed-icon {\n  opacity: 0;\n  transform: scale(0);\n  transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n}\n\n.payment-success-icon.animate {\n  opacity: 1;\n  transform: scale(1);\n  animation: brandPulse 1.6s ease-in-out;\n}\n\n.payment-failed-icon.animate {\n  opacity: 1;\n  transform: scale(1);\n  animation: brandShake 0.9s ease-in-out;\n}\n\n@keyframes brandPulse {\n  0%   { transform: scale(0);   opacity: 0; }\n  55%  { transform: scale(1.08); }\n  100% { transform: scale(1);   opacity: 1; }\n}\n\n@keyframes brandShake {\n  0%   { transform: scale(0)    rotate(0deg);  opacity: 0; }\n  50%  { transform: scale(1.08) rotate(-4deg); }\n  75%  { transform: scale(1.04) rotate(3deg); }\n  100% { transform: scale(1)    rotate(0deg);  opacity: 1; }\n}\n\n/* Inline info / error blocks on the result card */\n.payment-info-block {\n  background: #e8f4fb;\n  border: 1px solid #d0e8f8;\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin-top: 12px;\n  text-align: left;\n}\n\n.payment-info-block .payment-info-text {\n  font-size: 14px;\n  color: #045f95;\n}\n\n.error-details {\n  background: #fff2f0;\n  border: 1px solid #ffccc7;\n  border-radius: 8px;\n  padding: 14px 16px;\n  margin-top: 12px;\n  text-align: left;\n}\n\n.error-details ul {\n  margin: 8px 0 0;\n  padding-left: 20px;\n  color: #666;\n}\n\n.error-details li {\n  margin-bottom: 4px;\n}\n\n/* Subtle button motion in the result page (not too punchy) */\n.payment-result-container .ant-btn {\n  transition: all 0.2s ease;\n}\n\n.payment-result-container .ant-btn:hover {\n  transform: translateY(-1px);\n}\n\n/* Loading dot color matches the brand */\n.ant-spin-dot-item {\n  background-color: #0576b7 !important;\n}\n\n@media (max-width: 768px) {\n  .payment-result-container {\n    padding: 12px;\n  }\n\n  .payment-result-card .ant-card-body {\n    padding: 24px 18px;\n  }\n\n  .payment-success-icon,\n  .payment-failed-icon {\n    font-size: 60px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
